/**
 * The reports constants module houses reports-specific configurations.
 *
 * @module routes.reports.constants
 */

angular.module('routes.globalreports.constants', [])
  .config([
    '$provide',
    function ($provide) {
      'use strict';

      // Define.
      var globalreports;

      // Set defaults.
      globalreports = {};

      /**
       * Defines reports constants.
       *
       * @attribute REPORTS
       * @type String
       * @readOnly
       */
      $provide.constant('GLOBALREPORTS', globalreports);
    }
  ]);
